import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'CellSingleValue';

const classes = {
  container: `${PREFIX}-container`,
  value: `${PREFIX}-value`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '4px',
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20.02px',
    letterSpacing: '0.17px',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  [`& .${classes.value}`]: {
    color: 'rgba(1, 16, 18, 0.90)',
  },
}));

type CellSingleValueProps = {
  children: React.ReactNode;
};

const CellSingleValue = ({ children }: CellSingleValueProps) => (
  <StyledBox className={classes.container}>
    <span className={classes.value}>{children}</span>
  </StyledBox>
);

export { CellSingleValue };
export type { CellSingleValueProps };
